import React from 'react';

import { Typography as AntdTypo } from 'antd';

import BaseForm from 'components/BaseForm/BaseForm';
import BaseSelectJuridiction from 'components/BaseForm/Select/juridiction/BaseSelectJuridiction';
import BaseSelectTypeJuridiction from 'components/BaseForm/Select/juridiction/BaseSelectTypeJuridiction';
import { FilterDashboardJuridiction } from 'hooks/search/useSearchJuridictionQuery';
import { LABEL_ID_CORRELATION } from 'utils/global';

import FormFooter from './FormFooter/FormFooter';

interface FilterFormProps {
  filter: FilterDashboardJuridiction;
  setFilter: (value: FilterDashboardJuridiction) => void;
}

function FilterFormJuridiction({
  filter,
  setFilter,
}: FilterFormProps): React.ReactElement {
  return (
    <>
      <AntdTypo.Title level={3}>Filtres</AntdTypo.Title>
      <BaseForm
        initialValues={filter}
        inputs={[
          {
            name: 'idCorrelation',
            label: LABEL_ID_CORRELATION,
          },
          {
            name: 'origineElement',
            label: 'Origine',
          },
          {
            name: 'numero',
            label: 'Numero',
          },
          {
            name: 'type',
            label: 'Type de juridiction',
            render: () => <BaseSelectTypeJuridiction allowClear />,
          },
          {
            name: 'libelle',
            label: 'Libelle',
          },
          {
            name: 'idCorrelationJuridictionParentes',
            label: 'Juridiction parente',
            render: () => <BaseSelectJuridiction mode={'multiple'} />,
          },
          {
            name: 'codePostal',
            label: 'Code postal',
          },
        ]}
        onSubmit={() => Promise.resolve()}
        renderButtonAction={() => {
          return <FormFooter setFilter={setFilter} />;
        }}
      />
    </>
  );
}

export default FilterFormJuridiction;
